import React, { useEffect } from 'react';
import './Registro.scss';
import { Layout, AdBlock, AdImage } from '../../components';
import { Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { Link } from 'react-router-dom';

const Registro = () => {

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <Layout background="#1f2024">

            <div className="registro">
                <div className="registro__container--link">
                    <Link className="registro__Link" to="registro/usuarios">¿Sos usuario?</Link>
                </div>
                <div className="registro__container--link">
                    <Link className="registro__Link" to="registro/prestadores">¿Sos Prestador?</Link>
                </div>
            </div>
        </Layout>
    )
}

export default Registro;
